import axiosInstance from '../helpers/axiosInstance';

export const getDashboardApi = async () => {
    const response = await axiosInstance.get('staff/dashboard/count');
    return response.data;
};

export const getDashboardCountApi = async () => {
    const response = await axiosInstance.get('staff/dashboard/purchaseOrder/count');
    return response.data;
};

export const getDashboardOutofStockApi = async () => {
    const response = await axiosInstance.get('staff/products/outOfStock');
    return response.data;
};
